import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { popToast, chaosNotify } from '../utils/alerts.js';

const imagesSpheresFallback = [
    'sphere1.jpg', 'sphere2.jpg', 'sphere3.jpg', 'sphere4.jpg', 
    'sphere5.jpg', 'sphere6.jpg', 'sphere7.jpg', 'sphere8.jpg'
];

export function fermerModale() {
    const modal = document.getElementById('modal-container');
    if (modal) modal.style.display = 'none';
    const inputNom = document.getElementById('sphere-name-input');
    if (inputNom) inputNom.value = '';
}

export function creerMaSphere() {
    const nomInput = document.getElementById('sphere-name-input');
    const descInput = document.getElementById('sphere-desc-input');
    
    const nom = nomInput ? nomInput.value : "";
    const desc = descInput ? descInput.value : "";
    const estPrivee = true; 

    const pseudoCreateur = window.monPseudo || state.monPseudo;

    if (nom.trim()) {
        const indexAleatoire = Math.floor(Math.random() * imagesSpheresFallback.length);
        const imageChoisie = imagesSpheresFallback[indexAleatoire];
        
        const nouvelleSphere = {
            nom: nom,
            description: desc,
            createur: pseudoCreateur,
            icone: imageChoisie,
            est_privee: estPrivee 
        };

        socket.emit('creer-sphere', nouvelleSphere);
        fermerModale();
    } else {
        popToast(t('validate.sphere_no_name'), 'error');
    }
}

export function ouvrirSettingsSphere() {
    // 1. Cacher le menu contextuel clic droit
    const menu = document.getElementById('custom-context-menu');
    if (menu) menu.style.display = 'none';
    
    const activeSelectionId = window.sphereSelectionneeId || state.sphereSelectionneeId;
    if (!activeSelectionId) return;

    // 2. Trouver la sphère dans la mémoire globale
    const sphere = (window.mesSpheresActuelles || []).find(s => s.id === activeSelectionId);
    if (!sphere) return;

    // 3. Pré-remplir les champs de la modale
    const nameInput = document.getElementById('edit-sphere-name');
    const descInput = document.getElementById('edit-sphere-desc');
    if (nameInput) nameInput.value = sphere.nom || "";
    if (descInput) descInput.value = sphere.description || "";

    // 4. Afficher la modale
    const modalEdit = document.getElementById('modal-edit-sphere');
    if (modalEdit) modalEdit.style.display = 'flex';
}

export function validerEditSphere() {
    const activeSelectionId = window.sphereSelectionneeId || state.sphereSelectionneeId;
    const nouveauNom = document.getElementById('edit-sphere-name')?.value.trim();
    const nouvelleDesc = document.getElementById('edit-sphere-desc')?.value.trim();

    if (nouveauNom && activeSelectionId) {
        socket.emit('editer-sphere', { 
            id: activeSelectionId, 
            nom: nouveauNom, 
            description: nouvelleDesc 
        });
        
        const modalEdit = document.getElementById('modal-edit-sphere');
        if (modalEdit) modalEdit.style.display = 'none';
        popToast(t('toast.sphere_updating'));
    } else {
        popToast(t('validate.sphere_needs_name'), 'error');
    }
}

export async function quitterSphere() {
    const dropdown = document.getElementById('sphere-dropdown');
    if (dropdown) dropdown.style.display = 'none';

    const activeSphereId = window.sphereActuelleID || state.sphereActuelleID;
    if (!activeSphereId) return;

    const confirmation = await chaosNotify(
        t('confirm.leave_sphere'),
        t('confirm.leave_sphere_title'),
        "confirm"
    );

    if (confirmation) {
        socket.emit('quitter-sphere', activeSphereId);
    }
}

socket.on('sphere-quittee', ({ sphereId }) => {
    if ((window.sphereActuelleID || state.sphereActuelleID) === sphereId) {
        window.sphereActuelleID = null;
        state.sphereActuelleID = null;
        if (typeof window.naviguer === 'function') window.naviguer('dashboard');
    }
    popToast(t('toast.leave_sphere_success'), 'success');
});

export async function confirmerSuppressionSphere() {
    const activeSelectionId = window.sphereSelectionneeId || state.sphereSelectionneeId;
    if (!activeSelectionId) return;

    const confirmation = await chaosNotify(
        t('confirm.delete_sphere'),
        t('confirm.delete_sphere_title'),
        "confirm"
    );

    if (confirmation) {
        socket.emit('supprimer-sphere', activeSelectionId);
        if (typeof window.naviguer === 'function') window.naviguer('dashboard');
    }
}

export function toggleSphereMenu() {
    if (window.sphereActuelleID) {
        window.sphereSelectionneeId = window.sphereActuelleID;
        state.sphereSelectionneeId = window.sphereActuelleID;
    }

    const dropdown = document.getElementById('sphere-dropdown');
    if (!dropdown) return;
    const isHidden = dropdown.style.display === 'none' || dropdown.style.display === '';
    
    if (isHidden) {
        let html = `
            <div class="dropdown-item" onclick="window.genererLien()">
                <i class="fas fa-user-plus"></i> Inviter un allié
            </div>
        `;
        
        if (window.monRoleActuel === 'admin' || state.monRoleActuel === 'admin') {
            html += `
                <div class="dropdown-item" onclick="window.ouvrirSettingsSphere()">
                    <i class="fas fa-pen"></i> Modifier les paramètres
                </div>
                <div class="dropdown-item danger" onclick="window.confirmerSuppressionSphere()">
                    <i class="fas fa-trash"></i> Supprimer la Sphère
                </div>
            `;
        } else {
            html += `
                <div class="dropdown-item danger" onclick="window.quitterSphere()">
                    <i class="fas fa-door-open"></i> Quitter la Sphère
                </div>
            `;
        }
        
        dropdown.innerHTML = html;
        dropdown.style.display = 'block';
        
        const closeMenu = (e) => {
            if (!e.target.closest('.dropdown-wrapper')) {
                dropdown.style.display = 'none';
                document.removeEventListener('click', closeMenu);
            }
        };
        setTimeout(() => document.addEventListener('click', closeMenu), 10);
    } else {
        dropdown.style.display = 'none';
    }
}